import { useServices } from "contexts/ServiceContext";

const useConfigs = () => useServices().Configs;

export default useConfigs;
